<div class="application-page container-fluid">
  @if (!application) {
    <div class="row">
      <div class="col-lg-6 col-md-12">
        <message-box type="danger" title="Not found">
          Unable to location application
        </message-box>
      </div>
    </div>
  }
  @if (application) {
    @if (application.Status !== 'Draft') {
      <salesforce-sync-failed recordType="application" [recordId]="application.ApplicationId"
        [getDeadletteredSalesforceJobsFn]="getDeadletteredSalesforceJobsFn"
        [requeueDeadletteredSalesforceJobFn]="requeueDeadletteredSalesforceJobFn"></salesforce-sync-failed>
    }
    @if (application.ApplicationType === 'AssetFinance') {
      <asset-finance-application-details
        [assetSearchFn]="assetSearchFn"
        [getBankStatementsAnalysisFn]="getBankStatementsAnalysisFn"
        [getBankStatementAndBasiqDataStatusFn]="getBankStatementAndBasiqDataStatusFn"
        [getBasiqCustomerMappingByAbnFn]="getBasiqCustomerMappingByAbnFn"
        [getBasiqStatementDataForCompanyFn]="getBasiqStatementDataForCompanyFn"
        [refreshBasiqConnectionsFn]="refreshBasiqConnectionsFn"
        [getApplicationPpsrInfoFn]="getApplicationPpsrInfoFn"
        [removeApplicationAssetFn]="removeApplicationAssetFn"
        [searchAssetFn]="searchAssetFn"
        [initialSelection]="initialApplicationSelectionType"
        (selectionEvent)="onApplicationSelectionType($event)"
        [submitPpsrFn]="submitPpsrFn"
        [getApplicationAssetFn]="getApplicationAssetFn"
        [sendAssetToSfFn]="sendAssetToSfFn"
        [getPpsrDetailsFn]="getPpsrDetailsFn"
        [addPpsrDetailFn]="addPpsrDetailFn"
        [updatePpsrDetailFn]="updatePpsrDetailFn"
        [updateApplicationAssetsFn]="updateApplicationAssetsFn"
        [submitApplicationAssetsFn]="submitApplicationAssetsFn"
        [searchGrantorsFn]="searchGrantorsFn"
        [getPpsrDocumentsFn]="getPpsrDocumentsFn"
        [getOriginatorByIdFn]="getOriginatorByIdFn"
        [addIndividualFn]="addIndividualFn"
        [businessSearchFn]="businessSearchFn"
        [verifyOneApplicationIndividualFn]="verifyOneApplicationIndividualFn"
        [sendVerificationSmsFn]="sendVerificationSmsFn"
        [getApplicationIndividualsFn]="getApplicationIndividualsFn"
        [saveApplicationPartiesFn]="saveApplicationPartiesFn"
        [updateApplicationIndividualDigitalIdMappingFn]="updateApplicationIndividualDigitalIdMappingFn"
        [updateIndividualKycStatusFn]="updateIndividualKycStatusFn"
        [syncIndividualKycFromFrankieOneFn]="syncIndividualKycFromFrankieOneFn"
        [downloadDocumentFromAzureFn]="downloadDocumentFromAzureFn"
        [searchSupplierFn]="searchSupplierFn"
        [saveSupplierFn]="saveSupplierFn"
        [apiUrl]="apiUrl"
        [bankStatementsUrl]="bankStatementsUrl"
        [defaultSalesContactId]="defaultSalesContactId"
        [getUsersInCompanyFn]="getUsersInCompanyFn"
        [getUserByAccessLevelFn]="getUserByAccessLevelFn"
        (events)="onApplicationDetailsEvent($event)"
        [getRatecardDetailsFn]="getRatecardDetailsFn"
        [uploadApplicationDocumentFn]="uploadApplicationDocumentFn"
        [onBreadcrumbEventsFn]="onBreadcrumbEventFn"
        [getApplicationAuditLogsFn]="getApplicationAuditLogsFn"
        [getNotesByApplicationIdFn]="getNotesByApplicationIdFn"
        [assetSettlementSearchAssetsFn]="searchAssetFn"
        [listApplicationDocumentFn]="listApplicationDocumentFn"
        [downloadApplicationDocumentUrlFn]="downloadApplicationDocumentUrlFn"
        [approveApplicationDocumentFn]="approveApplicationDocumentFn"
        [declineApplicationDocumentFn]="declineApplicationDocumentFn"
        [deleteApplicationDocumentFn]="deleteApplicationDocumentFn"
        [downloadAllApplicationDocumentUrlFn]="downloadAllApplicationDocumentUrlFn"
        [updateApplicationDocumentTagsFn]="updateApplicationDocumentTagsFn"
        [updateApplicationRequiredDocumentsFn]="updateApplicationRequiredDocumentsFn"
        [createDocumentWorklistFn]="createDocumentWorklistFn"
        [completeDocumentWorklistFn]="completeDocumentWorklistFn"
        [sendContractEmailsFn]="sendContractEmailsFn"
        [updateDocumentMetadataFn]="updateDocumentMetadataFn"
        [getContractStatusFn]="getContractStatusFn"
        [generateContractFn]="generateContractFn"
        [deleteContractFileFn]="deleteContractFileFn"
        [getActiveContractForApplicationFn]="getActiveContractForApplicationFn"
        [declineContractFn]="declineContractFn"
        [createApplicationNoteFn]="createApplicationNoteFn"
        [removeApplicationNoteByNoteIdFn]="removeApplicationNoteByNoteIdFn"
        [createNewDisbursementFn]="createNewDisbursementFn"
        [updateDisbursementFn]="updateDisbursementFn"
        [getDisbursementByApplicationIdFn]="getDisbursementByApplicationIdFn"
        [syncDisbursementToSfFn]="syncDisbursementToSfFn"
        [syncBankDetailsToSfFn]="syncBankDetailsToSfFn"
        [syncDepositPaidToSfFn]="syncDepositPaidToSfFn"
        [syncPrivateSellerBankDetailsToSfFn]="syncPrivateSellerBankDetailsToSfFn"
        [syncContractDetailsToSfFn]="syncContractDetailsToSfFn"
        [businessNumberSearchFn]="businessNumberSearchFn"
        [getBillerNameFn]="getBillerNameFn"
        [getInstitutionNameFn]="getInstitutionNameFn"
        [validateBpayFn]="validateBpayFn"
        [allowContractGeneration]="allowContractGeneration"
        [updateApplicationStageFn]="updateApplicationStageFn"
        [getApplicationByIdFn]="getApplicationByIdFn"
        [settleLoanFn]="settleLoanFn"
        [generateApprovalNoticeFn]="generateApprovalNoticeFn"
        [sendApprovalNoticeEmailFn]="sendApprovalNoticeEmailFn"
        [deleteApprovalNoticeFileFn]="deleteApprovalNoticeFileFn"
        (navigateToApplications)="onNavigateToApplications()"
        (assetPricingEvents)="onAssetPricingEvents($event)"
        [undoApplicationDocumentFn]="undoApplicationDocumentFn"
        [refreshBankStatementFn]="refreshBankStatementFn"
        [getUserFn]="getUserFn"
        [getDscrCalculatorValueFn]="getDscrCalculatorValueFn"
        [updateDscrCalculatorValueFn]="updateDscrCalculatorValueFn"
        [getAccountDetailsFromSfFn]="getAccountDetailsFromSfFn"
        [getBankDetailsFromOpportunitySfFn]="getBankDetailsFromOpportunitySfFn"
        [extractTaxInvoiceFn]="extractTaxInvoiceFn"
        [updateApplicationFn]="updateApplicationFn"
        [updateApplicationSfFn]="updateApplicationSfFn"
        [createAssetInspectionFn]="createAssetInspectionFn"
        [getAssetInspectionsForApplicationFn]="getAssetInspectionsForApplicationFn"
        [downloadVerimotoReportFn]="downloadVerimotoReportFn"
        [verimotoLender]="verimotoLender"
        [verimotoAssetInspectionTypes]="verimotoAssetInspectionTypes"
        [getLvrCalculatorValueFn]="getLvrCalculatorValueFn"
        [updateLvrCalculatorValueFn]="updateLvrCalculatorValueFn"
        [getBsaLenderListFn]="getBsaLenderListFn"
        [getBsaExcludedLenderListFn]="getBsaExcludedLenderListFn"
        [saveBsaCalculatorFn]="saveBsaCalculatorFn"
        [getBsaCalculatorFn]="getBsaCalculatorFn"
        [runCreditFlowFn]="runCreditFlowFn"
        [getDscrCalculatorHistoryFn]="getDscrCalculatorHistoryFn"
        [getOriginatorBusinessByIdFn]="getOriginatorBusinessByIdFn"
        [addAuditLogFn]="addAuditLogFn"
        [getCreditWebServicesFn]="getCreditWebServicesFn"
        [getApplicationCreditFlowResultFn]="getApplicationCreditFlowResultFn"
        [getHistoricalContractsFn]="getHistoricalContractsFn"
        [getPismoContractsFn]="getPismoContractsFn"
        [downloadCreditorWatchReportFn]="downloadCreditorWatchReportFn"
        [updateCreditStatusFn]="updateCreditStatusFn"
        [updateCreditOfficerFn]="updateCreditOfficerFn"
        [getActiveCreditUsersFn]="getActiveCreditUsersFn"
        [getCreditAuditLogFn]="getCreditAuditLogFn"
        [getWebServiceReportFn]="getWebServiceReportFn"
        [getDuplicatedApplicationsFn]="getDuplicatedApplicationsFn"
        (clickApplicationEvent)="onClickApplicationEvent($event)"
        [deleteWebServicesFn]="deleteWebServicesFn"
        [requestMoreInformationFn]="requestMoreInformationFn"
        [withdrawApplicationFn]="withdrawApplicationFn"
        [getApplicationDscrFn]="getApplicationDscrFn"
        (refreshCreditTabEvent)="refreshCreditTab($event)"
        [resendContractFn]="resendContractFn"
        [application]="$any(application)"
        [getAggregatorsAndOriginatorsFn]="getAggregatorsAndOriginatorsFn"
        [getUserByAccessLevelFn]="getUserByAccessLevelFn"
        [getApplicationSettlementsOfficerFn]="getApplicationSettlementsOfficerFn"
        [getAmlOfficerCandidatesFn]="getAmlOfficerCandidatesFn">
      </asset-finance-application-details>
    }
    @if (application.ApplicationType === 'BusinessLoans') {
      <business-finance-application-details
        [getBankStatementsAnalysisFn]="getBankStatementsAnalysisFn"
        [getBankStatementAndBasiqDataStatusFn]="getBankStatementAndBasiqDataStatusFn"
        [getBasiqCustomerMappingByAbnFn]="getBasiqCustomerMappingByAbnFn"
        [refreshBasiqConnectionsFn]="refreshBasiqConnectionsFn"
        [getBasiqStatementDataForCompanyFn]="getBasiqStatementDataForCompanyFn"
        [createNewDisbursementFn]="createNewDisbursementFn"
        [updateDisbursementFn]="updateDisbursementFn"
        [getDisbursementByApplicationIdFn]="getDisbursementByApplicationIdFn"
        [syncDisbursementToSfFn]="syncDisbursementToSfFn"
        [businessNumberSearchFn]="businessNumberSearchFn"
        [syncBankDetailsToSfFn]="syncBankDetailsToSfFn"
        [sendAssetToSfFn]="sendAssetToSfFn"
        [getApplicationAuditLogsFn]="getApplicationAuditLogsFn"
        [getLvrCalculatorValueFn]="getLvrCalculatorValueFn"
        [updateLvrCalculatorValueFn]="updateLvrCalculatorValueFn"
        [getDscrCalculatorValueFn]="getDscrCalculatorValueFn"
        [updateDscrCalculatorValueFn]="updateDscrCalculatorValueFn"
        [getOriginatorByIdFn]="getOriginatorByIdFn"
        [addIndividualFn]="addIndividualFn"
        [initialSelection]="initialApplicationSelectionType"
        (selectionEvent)="onApplicationSelectionType($event)"
        [verifyOneApplicationIndividualFn]="verifyOneApplicationIndividualFn"
        [sendVerificationSmsFn]="sendVerificationSmsFn"
        [getApplicationIndividualsFn]="getApplicationIndividualsFn"
        [saveApplicationPartiesFn]="saveApplicationPartiesFn"
        [businessSearchFn]="businessSearchFn"
        [updateApplicationIndividualDigitalIdMappingFn]="updateApplicationIndividualDigitalIdMappingFn"
        [updateIndividualKycStatusFn]="updateIndividualKycStatusFn"
        [syncIndividualKycFromFrankieOneFn]="syncIndividualKycFromFrankieOneFn"
        [downloadDocumentFromAzureFn]="downloadDocumentFromAzureFn"
        [apiUrl]="apiUrl"
        [bankStatementsUrl]="bankStatementsUrl"
        [getUsersInCompanyFn]="getUsersInCompanyFn"
        (events)="onApplicationDetailsEvent($event)"
        (businessPricingEvents)="onBusinessPricingEvents($event)"
        [getRatecardDetailsFn]="getRatecardDetailsFn"
        [uploadApplicationDocumentFn]="uploadApplicationDocumentFn"
        [onBreadcrumbEventsFn]="onBreadcrumbEventFn"
        [listApplicationDocumentFn]="listApplicationDocumentFn"
        [downloadApplicationDocumentUrlFn]="downloadApplicationDocumentUrlFn"
        [approveApplicationDocumentFn]="approveApplicationDocumentFn"
        [declineApplicationDocumentFn]="declineApplicationDocumentFn"
        [deleteApplicationDocumentFn]="deleteApplicationDocumentFn"
        [downloadAllApplicationDocumentUrlFn]="downloadAllApplicationDocumentUrlFn"
        [updateApplicationDocumentTagsFn]="updateApplicationDocumentTagsFn"
        [updateApplicationRequiredDocumentsFn]="updateApplicationRequiredDocumentsFn"
        [createDocumentWorklistFn]="createDocumentWorklistFn"
        [completeDocumentWorklistFn]="completeDocumentWorklistFn"
        [getContractStatusFn]="getContractStatusFn"
        [generateContractFn]="generateContractFn"
        [deleteContractFileFn]="deleteContractFileFn"
        [getActiveContractForApplicationFn]="getActiveContractForApplicationFn"
        [declineContractFn]="declineContractFn"
        [sendContractEmailsFn]="sendContractEmailsFn"
        [createApplicationNoteFn]="createApplicationNoteFn"
        [removeApplicationNoteByNoteIdFn]="removeApplicationNoteByNoteIdFn"
        [getNotesByApplicationIdFn]="getNotesByApplicationIdFn"
        [syncContractDetailsToSfFn]="syncContractDetailsToSfFn"
        [getBillerNameFn]="getBillerNameFn"
        [getInstitutionNameFn]="getInstitutionNameFn"
        [validateBpayFn]="validateBpayFn"
        [allowContractGeneration]="allowContractGeneration"
        [updateApplicationStageFn]="updateApplicationStageFn"
        [getApplicationByIdFn]="getApplicationByIdFn"
        [settleLoanFn]="settleLoanFn"
        [searchSupplierFn]="searchSupplierFn"
        [getBankDetailsFromOpportunitySfFn]="getBankDetailsFromOpportunitySfFn"
        [generateApprovalNoticeFn]="generateApprovalNoticeFn"
        [sendApprovalNoticeEmailFn]="sendApprovalNoticeEmailFn"
        [deleteApprovalNoticeFileFn]="deleteApprovalNoticeFileFn"
        (navigateToApplications)="onNavigateToApplications()"
        [undoApplicationDocumentFn]="undoApplicationDocumentFn"
        [refreshBankStatementFn]="refreshBankStatementFn"
        [getAccountDetailsFromSfFn]="getAccountDetailsFromSfFn"
        [getUserFn]="getUserFn"
        [searchGrantorsFn]="searchGrantorsFn"
        [getPpsrDetailsFn]="getPpsrDetailsFn"
        [updateApplicationFn]="updateApplicationFn"
        [updateApplicationSfFn]="updateApplicationSfFn"
        [getApplicationAssetFn]="getApplicationAssetFn"
        [getBsaLenderListFn]="getBsaLenderListFn"
        [getBsaExcludedLenderListFn]="getBsaExcludedLenderListFn"
        [saveBsaCalculatorFn]="saveBsaCalculatorFn"
        [getBsaCalculatorFn]="getBsaCalculatorFn"
        [getDscrCalculatorHistoryFn]="getDscrCalculatorHistoryFn"
        [getOriginatorBusinessByIdFn]="getOriginatorBusinessByIdFn"
        [addAuditLogFn]="addAuditLogFn"
        [runCreditFlowFn]="runCreditFlowFn" 
        [getCreditWebServicesFn]="getCreditWebServicesFn"
        [getApplicationCreditFlowResultFn]="getApplicationCreditFlowResultFn"
        [getHistoricalContractsFn]="getHistoricalContractsFn"
        [getPismoContractsFn]="getPismoContractsFn"
        [downloadCreditorWatchReportFn]="downloadCreditorWatchReportFn"
        [updateCreditStatusFn]="updateCreditStatusFn"
        [updateCreditOfficerFn]="updateCreditOfficerFn"
        [getActiveCreditUsersFn]="getActiveCreditUsersFn"
        [getCreditAuditLogFn]="getCreditAuditLogFn"
        [getWebServiceReportFn]="getWebServiceReportFn"
        [getDuplicatedApplicationsFn]="getDuplicatedApplicationsFn"
        (clickApplicationEvent)="onClickApplicationEvent($event)"
        [deleteWebServicesFn]="deleteWebServicesFn"
        [requestMoreInformationFn]="requestMoreInformationFn"
        [withdrawApplicationFn]="withdrawApplicationFn"
        (refreshCreditTabEvent)="refreshCreditTab($event)"
        [getApplicationDscrFn]="getApplicationDscrFn"
        [resendContractFn]="resendContractFn"
        [application]="$any(application)"
        [getAggregatorsAndOriginatorsFn]="getAggregatorsAndOriginatorsFn"
        [getUserByAccessLevelFn]="getUserByAccessLevelFn"
        [getApplicationSettlementsOfficerFn]="getApplicationSettlementsOfficerFn"
        [getAmlOfficerCandidatesFn]="getAmlOfficerCandidatesFn">
        
      </business-finance-application-details>
    }
    @if (application.ApplicationType ==='BusinessOverdraft') {
      <business-overdraft-application-details
        [getBankStatementsAnalysisFn]="getBankStatementsAnalysisFn"
        [getBankStatementAndBasiqDataStatusFn]="getBankStatementAndBasiqDataStatusFn"
        [getBasiqCustomerMappingByAbnFn]="getBasiqCustomerMappingByAbnFn"
        [refreshBasiqConnectionsFn]="refreshBasiqConnectionsFn"
        [getBasiqStatementDataForCompanyFn]="getBasiqStatementDataForCompanyFn"
        [createNewDisbursementFn]="createNewDisbursementFn"
        [updateDisbursementFn]="updateDisbursementFn"
        [getDisbursementByApplicationIdFn]="getDisbursementByApplicationIdFn"
        [syncDisbursementToSfFn]="syncDisbursementToSfFn"
        [businessNumberSearchFn]="businessNumberSearchFn"
        [syncBankDetailsToSfFn]="syncBankDetailsToSfFn"
        [sendAssetToSfFn]="sendAssetToSfFn"
        [getApplicationAuditLogsFn]="getApplicationAuditLogsFn"
        [getLvrCalculatorValueFn]="getLvrCalculatorValueFn"
        [updateLvrCalculatorValueFn]="updateLvrCalculatorValueFn"
        [getDscrCalculatorValueFn]="getDscrCalculatorValueFn"
        [updateDscrCalculatorValueFn]="updateDscrCalculatorValueFn"
        [getOriginatorByIdFn]="getOriginatorByIdFn"
        [addIndividualFn]="addIndividualFn"
        [initialSelection]="initialApplicationSelectionType"
        (selectionEvent)="onApplicationSelectionType($event)"
        [verifyOneApplicationIndividualFn]="verifyOneApplicationIndividualFn"
        [sendVerificationSmsFn]="sendVerificationSmsFn"
        [getApplicationIndividualsFn]="getApplicationIndividualsFn"
        [saveApplicationPartiesFn]="saveApplicationPartiesFn"
        [businessSearchFn]="businessSearchFn"
        [updateApplicationIndividualDigitalIdMappingFn]="updateApplicationIndividualDigitalIdMappingFn"
        [updateIndividualKycStatusFn]="updateIndividualKycStatusFn"
        [syncIndividualKycFromFrankieOneFn]="syncIndividualKycFromFrankieOneFn"
        [downloadDocumentFromAzureFn]="downloadDocumentFromAzureFn"
        [apiUrl]="apiUrl"
        [bankStatementsUrl]="bankStatementsUrl"
        [getUsersInCompanyFn]="getUsersInCompanyFn"
        (events)="onApplicationDetailsEvent($event)"
        (businessOverdraftPricingEvents)="onBusinessOverdraftPricingEvents($event)"
        [getRatecardDetailsFn]="getRatecardDetailsFn"
        [uploadApplicationDocumentFn]="uploadApplicationDocumentFn"
        [listApplicationDocumentFn]="listApplicationDocumentFn"
        [downloadApplicationDocumentUrlFn]="downloadApplicationDocumentUrlFn"
        [approveApplicationDocumentFn]="approveApplicationDocumentFn"
        [declineApplicationDocumentFn]="declineApplicationDocumentFn"
        [deleteApplicationDocumentFn]="deleteApplicationDocumentFn"
        [downloadAllApplicationDocumentUrlFn]="downloadAllApplicationDocumentUrlFn"
        [updateApplicationDocumentTagsFn]="updateApplicationDocumentTagsFn"
        [updateApplicationRequiredDocumentsFn]="updateApplicationRequiredDocumentsFn"
        [createDocumentWorklistFn]="createDocumentWorklistFn"
        [completeDocumentWorklistFn]="completeDocumentWorklistFn"
        [onBreadcrumbEventsFn]="onBreadcrumbEventFn"
        [getContractStatusFn]="getContractStatusFn"
        [generateContractFn]="generateContractFn"
        [deleteContractFileFn]="deleteContractFileFn"
        [getActiveContractForApplicationFn]="getActiveContractForApplicationFn"
        [declineContractFn]="declineContractFn"
        [sendContractEmailsFn]="sendContractEmailsFn"
        [getNotesByApplicationIdFn]="getNotesByApplicationIdFn"
        [createApplicationNoteFn]="createApplicationNoteFn"
        [removeApplicationNoteByNoteIdFn]="removeApplicationNoteByNoteIdFn"
        [syncContractDetailsToSfFn]="syncContractDetailsToSfFn"
        [allowContractGeneration]="allowContractGeneration"
        [updateApplicationStageFn]="updateApplicationStageFn"
        [getApplicationByIdFn]="getApplicationByIdFn"
        [settleLoanFn]="settleLoanFn"
        [generateApprovalNoticeFn]="generateApprovalNoticeFn"
        [sendApprovalNoticeEmailFn]="sendApprovalNoticeEmailFn"
        [deleteApprovalNoticeFileFn]="deleteApprovalNoticeFileFn"
        [undoApplicationDocumentFn]="undoApplicationDocumentFn"
        (navigateToApplications)="onNavigateToApplications()"
        [refreshBankStatementFn]="refreshBankStatementFn"
        [getAccountDetailsFromSfFn]="getAccountDetailsFromSfFn"
        [searchGrantorsFn]="searchGrantorsFn"
        [getPpsrDetailsFn]="getPpsrDetailsFn"
        [getUserFn]="getUserFn"
        [updateApplicationFn]="updateApplicationFn"
        [updateApplicationSfFn]="updateApplicationSfFn"
        [getApplicationAssetFn]="getApplicationAssetFn"
        [getBsaLenderListFn]="getBsaLenderListFn"
        [getBsaExcludedLenderListFn]="getBsaExcludedLenderListFn"
        [saveBsaCalculatorFn]="saveBsaCalculatorFn"
        [getBsaCalculatorFn]="getBsaCalculatorFn"
        [getDscrCalculatorHistoryFn]="getDscrCalculatorHistoryFn"
        [getOriginatorBusinessByIdFn]="getOriginatorBusinessByIdFn"
        [runCreditFlowFn]="runCreditFlowFn"
        [getCreditWebServicesFn]="getCreditWebServicesFn"
        [getApplicationCreditFlowResultFn]="getApplicationCreditFlowResultFn"
        [getHistoricalContractsFn]="getHistoricalContractsFn"
        [getPismoContractsFn]="getPismoContractsFn"
        [downloadCreditorWatchReportFn]="downloadCreditorWatchReportFn"
        [updateCreditStatusFn]="updateCreditStatusFn"
        [updateCreditOfficerFn]="updateCreditOfficerFn"
        [getActiveCreditUsersFn]="getActiveCreditUsersFn"
        [getCreditAuditLogFn]="getCreditAuditLogFn"
        [getWebServiceReportFn]="getWebServiceReportFn"
        [getDuplicatedApplicationsFn]="getDuplicatedApplicationsFn"
        (clickApplicationEvent)="onClickApplicationEvent($event)"
        [deleteWebServicesFn]="deleteWebServicesFn"
        [withdrawApplicationFn]="withdrawApplicationFn"
        [requestMoreInformationFn]="requestMoreInformationFn"
        (refreshCreditTabEvent)="refreshCreditTab($event)"
        [getApplicationDscrFn]="getApplicationDscrFn"
        [resendContractFn]="resendContractFn"
        [application]="$any(application)"
        [getAggregatorsAndOriginatorsFn]="getAggregatorsAndOriginatorsFn"
        [getUserByAccessLevelFn]="getUserByAccessLevelFn"
        [getApplicationSettlementsOfficerFn]="getApplicationSettlementsOfficerFn"
        [getAmlOfficerCandidatesFn]="getAmlOfficerCandidatesFn">
      </business-overdraft-application-details>
    }
    @if (application.ApplicationType === 'Consumer') {
      <consumer-finance-application-details
        [saveSupplierFn]="saveSupplierFn"
        [getBankStatementAndBasiqDataStatusFn]="getBankStatementAndBasiqDataStatusFn"
        [getBasiqCustomerMappingByAbnFn]="getBasiqCustomerMappingByAbnFn"
        [refreshBasiqConnectionsFn]="refreshBasiqConnectionsFn"
        [getBasiqStatementDataForCompanyFn]="getBasiqStatementDataForCompanyFn"
        [assetSearchFn]="assetSearchFn"
        [getBankStatementsAnalysisFn]="getBankStatementsAnalysisFn"
        [removeApplicationAssetFn]="removeApplicationAssetFn"
        [getApplicationPpsrInfoFn]="getApplicationPpsrInfoFn"
        [getApplicationAuditLogsFn]="getApplicationAuditLogsFn"
        [searchAssetFn]="searchAssetFn"
        [searchSupplierFn]="searchSupplierFn"
        [assetSettlementSearchAssetsFn]="searchAssetFn"
        [getOriginatorByIdFn]="getOriginatorByIdFn"
        [addIndividualFn]="addIndividualFn"
        [businessSearchFn]="businessSearchFn"
        [initialSelection]="initialApplicationSelectionType"
        (selectionEvent)="onApplicationSelectionType($event)"
        [verifyOneApplicationIndividualFn]="verifyOneApplicationIndividualFn"
        [sendVerificationSmsFn]="sendVerificationSmsFn"
        [getApplicationIndividualsFn]="getApplicationIndividualsFn"
        [saveApplicationPartiesFn]="saveApplicationPartiesFn"
        [updateApplicationIndividualDigitalIdMappingFn]="updateApplicationIndividualDigitalIdMappingFn"
        [updateIndividualKycStatusFn]="updateIndividualKycStatusFn"
        [syncIndividualKycFromFrankieOneFn]="syncIndividualKycFromFrankieOneFn"
        [downloadDocumentFromAzureFn]="downloadDocumentFromAzureFn"
        [apiUrl]="apiUrl"
        [bankStatementsUrl]="bankStatementsUrl"
        [getUsersInCompanyFn]="getUsersInCompanyFn"
        (events)="onApplicationDetailsEvent($event)"
        [onBreadcrumbEventsFn]="onBreadcrumbEventFn"
        [uploadApplicationDocumentFn]="uploadApplicationDocumentFn"
        [listApplicationDocumentFn]="listApplicationDocumentFn"
        [downloadApplicationDocumentUrlFn]="downloadApplicationDocumentUrlFn"
        [approveApplicationDocumentFn]="approveApplicationDocumentFn"
        [declineApplicationDocumentFn]="declineApplicationDocumentFn"
        [deleteApplicationDocumentFn]="deleteApplicationDocumentFn"
        [downloadAllApplicationDocumentUrlFn]="downloadAllApplicationDocumentUrlFn"
        [updateApplicationDocumentTagsFn]="updateApplicationDocumentTagsFn"
        [updateApplicationRequiredDocumentsFn]="updateApplicationRequiredDocumentsFn"
         
        [createDocumentWorklistFn]="createDocumentWorklistFn"
        [completeDocumentWorklistFn]="completeDocumentWorklistFn"
        [application]="$any(application)"
        [getApplicationAssetFn]="getApplicationAssetFn"
        [sendAssetToSfFn]="sendAssetToSfFn"
        [getPpsrDetailsFn]="getPpsrDetailsFn"
        [addPpsrDetailFn]="addPpsrDetailFn"
        [updatePpsrDetailFn]="updatePpsrDetailFn"
        [updateApplicationAssetsFn]="updateApplicationAssetsFn"
        [submitApplicationAssetsFn]="submitApplicationAssetsFn"
        [searchGrantorsFn]="searchGrantorsFn"
        [getPpsrDocumentsFn]="getPpsrDocumentsFn"
        [updateDocumentMetadataFn]="updateDocumentMetadataFn"
        [getContractStatusFn]="getContractStatusFn"
        [getActiveContractForApplicationFn]="getActiveContractForApplicationFn"
        [declineContractFn]="declineContractFn"
        [getNotesByApplicationIdFn]="getNotesByApplicationIdFn"
        [createApplicationNoteFn]="createApplicationNoteFn"
        [removeApplicationNoteByNoteIdFn]="removeApplicationNoteByNoteIdFn"
        [createNewDisbursementFn]="createNewDisbursementFn"
        [updateDisbursementFn]="updateDisbursementFn"
        [getDisbursementByApplicationIdFn]="getDisbursementByApplicationIdFn"
        [syncDisbursementToSfFn]="syncDisbursementToSfFn"
        [syncBankDetailsToSfFn]="syncBankDetailsToSfFn"
        [syncPrivateSellerBankDetailsToSfFn]="syncPrivateSellerBankDetailsToSfFn"
        [syncDepositPaidToSfFn]="syncDepositPaidToSfFn"
        [businessNumberSearchFn]="businessNumberSearchFn"
        [allowContractGeneration]="allowContractGeneration"
        [getBillerNameFn]="getBillerNameFn"
        [getInstitutionNameFn]="getInstitutionNameFn"
        [validateBpayFn]="validateBpayFn"
        [updateApplicationStageFn]="updateApplicationStageFn"
        [getApplicationByIdFn]="getApplicationByIdFn"
        [settleLoanFn]="settleLoanFn"
        [generateApprovalNoticeFn]="generateApprovalNoticeFn"
        [sendApprovalNoticeEmailFn]="sendApprovalNoticeEmailFn"
        [deleteApprovalNoticeFileFn]="deleteApprovalNoticeFileFn"
        [undoApplicationDocumentFn]="undoApplicationDocumentFn"
        [refreshBankStatementFn]="refreshBankStatementFn"
        [getUserFn]="getUserFn"
        [getAccountDetailsFromSfFn]="getAccountDetailsFromSfFn"
        [getBankDetailsFromOpportunitySfFn]="getBankDetailsFromOpportunitySfFn"
        [extractTaxInvoiceFn]="extractTaxInvoiceFn"
        [updateApplicationFn]="updateApplicationFn"
        [createAssetInspectionFn]="createAssetInspectionFn"
        [getAssetInspectionsForApplicationFn]="getAssetInspectionsForApplicationFn"
        [downloadVerimotoReportFn]="downloadVerimotoReportFn"
        [verimotoLender]="verimotoLender"
        [verimotoAssetInspectionTypes]="verimotoAssetInspectionTypes"
        [updateApplicationSfFn]="updateApplicationSfFn"
        [getBsaLenderListFn]="getBsaLenderListFn"
        [getBsaExcludedLenderListFn]="getBsaExcludedLenderListFn"
        [saveBsaCalculatorFn]="saveBsaCalculatorFn"
        [getBsaCalculatorFn]="getBsaCalculatorFn"
        [updateDscrCalculatorValueFn]="updateDscrCalculatorValueFn"
        [getDscrCalculatorValueFn]="getDscrCalculatorValueFn"
        [getDscrCalculatorHistoryFn]="getDscrCalculatorHistoryFn"
        [addAuditLogFn]="addAuditLogFn"
        [runCreditFlowFn]="runCreditFlowFn"
        [getCreditWebServicesFn]="getCreditWebServicesFn"
        [getApplicationCreditFlowResultFn]="getApplicationCreditFlowResultFn"
        [getHistoricalContractsFn]="getHistoricalContractsFn"
        [getPismoContractsFn]="getPismoContractsFn"
        [downloadCreditorWatchReportFn]="downloadCreditorWatchReportFn"
        [updateCreditStatusFn]="updateCreditStatusFn"
        [updateCreditOfficerFn]="updateCreditOfficerFn"
        [getActiveCreditUsersFn]="getActiveCreditUsersFn"
        [getCreditAuditLogFn]="getCreditAuditLogFn"
        [getWebServiceReportFn]="getWebServiceReportFn"
        [getDuplicatedApplicationsFn]="getDuplicatedApplicationsFn"
        [deleteWebServicesFn]="deleteWebServicesFn"
        [requestMoreInformationFn]="requestMoreInformationFn"
        [withdrawApplicationFn]="withdrawApplicationFn"
        [getApplicationDscrFn]="getApplicationDscrFn"
        [resendContractFn]="resendContractFn"
        (clickApplicationEvent)="onClickApplicationEvent($event)"
        (navigateToApplications)="onNavigateToApplications()"
        (refreshCreditTabEvent)="refreshCreditTab($event)"
        [getAggregatorsAndOriginatorsFn]="getAggregatorsAndOriginatorsFn"
        [getUserByAccessLevelFn]="getUserByAccessLevelFn"
        [getApplicationSettlementsOfficerFn]="getApplicationSettlementsOfficerFn"
        [getAmlOfficerCandidatesFn]="getAmlOfficerCandidatesFn">
        >
      </consumer-finance-application-details>
    }
    @if (application.ApplicationType === 'InsurancePremium') {
      <insurance-premium-application-details
        [getApplicationByIdFn]="getApplicationByIdFn"
        [getBankStatementAndBasiqDataStatusFn]="getBankStatementAndBasiqDataStatusFn"
        [getBasiqCustomerMappingByAbnFn]="getBasiqCustomerMappingByAbnFn"
        [refreshBasiqConnectionsFn]="refreshBasiqConnectionsFn"
        [getBasiqStatementDataForCompanyFn]="getBasiqStatementDataForCompanyFn"
        [getBankStatementsAnalysisFn]="getBankStatementsAnalysisFn"
        [getOriginatorByIdFn]="getOriginatorByIdFn"
        [addIndividualFn]="addIndividualFn"
        [businessSearchFn]="businessSearchFn"
        [initialSelection]="initialApplicationSelectionType"
        (selectionEvent)="onApplicationSelectionType($event)"
        [verifyOneApplicationIndividualFn]="verifyOneApplicationIndividualFn"
        [sendVerificationSmsFn]="sendVerificationSmsFn"
        [getApplicationIndividualsFn]="getApplicationIndividualsFn"
        [saveApplicationPartiesFn]="saveApplicationPartiesFn"
        [updateApplicationIndividualDigitalIdMappingFn]="updateApplicationIndividualDigitalIdMappingFn"
        [updateIndividualKycStatusFn]="updateIndividualKycStatusFn"
        [syncIndividualKycFromFrankieOneFn]="syncIndividualKycFromFrankieOneFn"
        [downloadDocumentFromAzureFn]="downloadDocumentFromAzureFn"
        [listApplicationDocumentFn]="listApplicationDocumentFn"
        [downloadApplicationDocumentUrlFn]="downloadApplicationDocumentUrlFn"
        [approveApplicationDocumentFn]="approveApplicationDocumentFn"
        [declineApplicationDocumentFn]="declineApplicationDocumentFn"
        [deleteApplicationDocumentFn]="deleteApplicationDocumentFn"
        [downloadAllApplicationDocumentUrlFn]="downloadAllApplicationDocumentUrlFn"
        [updateApplicationDocumentTagsFn]="updateApplicationDocumentTagsFn"
        [updateApplicationRequiredDocumentsFn]="updateApplicationRequiredDocumentsFn"
        [createDocumentWorklistFn]="createDocumentWorklistFn"
        [completeDocumentWorklistFn]="completeDocumentWorklistFn"
        [apiUrl]="apiUrl"
        [bankStatementsUrl]="bankStatementsUrl"
        [getUsersInCompanyFn]="getUsersInCompanyFn"
        (events)="onApplicationDetailsEvent($event)"
        [uploadApplicationDocumentFn]="uploadApplicationDocumentFn"
        [onBreadcrumbEventsFn]="onBreadcrumbEventFn"
        [getNotesByApplicationIdFn]="getNotesByApplicationIdFn"
        [createApplicationNoteFn]="createApplicationNoteFn"
        [removeApplicationNoteByNoteIdFn]="removeApplicationNoteByNoteIdFn"
        [businessNumberSearchFn]="businessNumberSearchFn"
        [getRatecardDetailsFn]="getRatecardDetailsFn"
        [undoApplicationDocumentFn]="undoApplicationDocumentFn"
        [refreshBankStatementFn]="refreshBankStatementFn"
        [getUserFn]="getUserFn"
        [generateApprovalNoticeFn]="generateApprovalNoticeFn"
        [sendApprovalNoticeEmailFn]="sendApprovalNoticeEmailFn"
        [deleteApprovalNoticeFileFn]="deleteApprovalNoticeFileFn"
        [updateApplicationStageFn]="updateApplicationStageFn"
        [getApplicationAssetFn]="getApplicationAssetFn"
        [getDisbursementByApplicationIdFn]="getDisbursementByApplicationIdFn"
        [settleLoanFn]="settleLoanFn"
        [getBsaLenderListFn]="getBsaLenderListFn"
        [getBsaExcludedLenderListFn]="getBsaExcludedLenderListFn"
        [saveBsaCalculatorFn]="saveBsaCalculatorFn"
        [getBsaCalculatorFn]="getBsaCalculatorFn"
        [updateDscrCalculatorValueFn]="updateDscrCalculatorValueFn"
        [getDscrCalculatorValueFn]="getDscrCalculatorValueFn"
        [getDscrCalculatorHistoryFn]="getDscrCalculatorHistoryFn"
        [runCreditFlowFn]="runCreditFlowFn"
        [getCreditWebServicesFn]="getCreditWebServicesFn"
        [getApplicationCreditFlowResultFn]="getApplicationCreditFlowResultFn"
        [getHistoricalContractsFn]="getHistoricalContractsFn"
        [getPismoContractsFn]="getPismoContractsFn"
        [downloadCreditorWatchReportFn]="downloadCreditorWatchReportFn"
        [updateCreditStatusFn]="updateCreditStatusFn"
        [updateCreditOfficerFn]="updateCreditOfficerFn"
        [getActiveCreditUsersFn]="getActiveCreditUsersFn"
        [getCreditAuditLogFn]="getCreditAuditLogFn"
        [getWebServiceReportFn]="getWebServiceReportFn"
        [getDuplicatedApplicationsFn]="getDuplicatedApplicationsFn"
        [deleteWebServicesFn]="deleteWebServicesFn"
        [requestMoreInformationFn]="requestMoreInformationFn"
        [withdrawApplicationFn]="withdrawApplicationFn"
        (clickApplicationEvent)="onClickApplicationEvent($event)"
        (navigateToApplications)="onNavigateToApplications()"
        (refreshCreditTabEvent)="refreshCreditTab($event)"
        [getApplicationAuditLogsFn]="getApplicationAuditLogsFn"
        [getApplicationDscrFn]="getApplicationDscrFn"
        [application]="$any(application)"
        [getAggregatorsAndOriginatorsFn]="getAggregatorsAndOriginatorsFn"
        [getUserByAccessLevelFn]="getUserByAccessLevelFn"
        [getApplicationSettlementsOfficerFn]="getApplicationSettlementsOfficerFn"
        [getAmlOfficerCandidatesFn]="getAmlOfficerCandidatesFn">

        >
      </insurance-premium-application-details>
    }

    @if (application.ApplicationType === 'CorporateLoans') {
      <corporate-loans-application-details
      [getBankStatementAndBasiqDataStatusFn]="getBankStatementAndBasiqDataStatusFn"
        [getBasiqCustomerMappingByAbnFn]="getBasiqCustomerMappingByAbnFn"
        [refreshBasiqConnectionsFn]="refreshBasiqConnectionsFn"
        [getBasiqStatementDataForCompanyFn]="getBasiqStatementDataForCompanyFn"
        [getApplicationByIdFn]="getApplicationByIdFn"
        [getBankStatementsAnalysisFn]="getBankStatementsAnalysisFn"
        [getOriginatorByIdFn]="getOriginatorByIdFn"
        [addIndividualFn]="addIndividualFn"
        [businessSearchFn]="businessSearchFn"
        [initialSelection]="initialApplicationSelectionType"
        (selectionEvent)="onApplicationSelectionType($event)"
        [verifyOneApplicationIndividualFn]="verifyOneApplicationIndividualFn"
        [sendVerificationSmsFn]="sendVerificationSmsFn"
        [getApplicationIndividualsFn]="getApplicationIndividualsFn"
        [saveApplicationPartiesFn]="saveApplicationPartiesFn"
        [updateApplicationIndividualDigitalIdMappingFn]="updateApplicationIndividualDigitalIdMappingFn"
        [updateIndividualKycStatusFn]="updateIndividualKycStatusFn"
        [syncIndividualKycFromFrankieOneFn]="syncIndividualKycFromFrankieOneFn"
        [downloadDocumentFromAzureFn]="downloadDocumentFromAzureFn"
        [apiUrl]="apiUrl"
        [bankStatementsUrl]="bankStatementsUrl"
        [getUsersInCompanyFn]="getUsersInCompanyFn"
        (navigateToApplications)="onNavigateToApplications()"
        (events)="onApplicationDetailsEvent($event)"
        [uploadApplicationDocumentFn]="uploadApplicationDocumentFn"
        [listApplicationDocumentFn]="listApplicationDocumentFn"
        [downloadApplicationDocumentUrlFn]="downloadApplicationDocumentUrlFn"
        [approveApplicationDocumentFn]="approveApplicationDocumentFn"
        [declineApplicationDocumentFn]="declineApplicationDocumentFn"
        [deleteApplicationDocumentFn]="deleteApplicationDocumentFn"
        [undoApplicationDocumentFn]="undoApplicationDocumentFn"
        [downloadAllApplicationDocumentUrlFn]="downloadAllApplicationDocumentUrlFn"
        [updateApplicationDocumentTagsFn]="updateApplicationDocumentTagsFn"
        [updateApplicationRequiredDocumentsFn]="updateApplicationRequiredDocumentsFn"
         
        [createDocumentWorklistFn]="createDocumentWorklistFn"
        [completeDocumentWorklistFn]="completeDocumentWorklistFn"
        [onBreadcrumbEventsFn]="onBreadcrumbEventFn"
        [getNotesByApplicationIdFn]="getNotesByApplicationIdFn"
        [createApplicationNoteFn]="createApplicationNoteFn"
        [removeApplicationNoteByNoteIdFn]="removeApplicationNoteByNoteIdFn"
        [businessNumberSearchFn]="businessNumberSearchFn"
        [refreshBankStatementFn]="refreshBankStatementFn"
        [getUserFn]="getUserFn"
        [getContractStatusFn]="getContractStatusFn"
        [generateApprovalNoticeFn]="generateApprovalNoticeFn"
        [sendApprovalNoticeEmailFn]="sendApprovalNoticeEmailFn"
        [deleteApprovalNoticeFileFn]="deleteApprovalNoticeFileFn"
        [updateApplicationStageFn]="updateApplicationStageFn"
        [getApplicationAssetFn]="getApplicationAssetFn"
        [getDisbursementByApplicationIdFn]="getDisbursementByApplicationIdFn"
        [settleLoanFn]="settleLoanFn"
        [getBsaLenderListFn]="getBsaLenderListFn"
        [getBsaExcludedLenderListFn]="getBsaExcludedLenderListFn"
        [saveBsaCalculatorFn]="saveBsaCalculatorFn"
        [getBsaCalculatorFn]="getBsaCalculatorFn"
        [updateDscrCalculatorValueFn]="updateDscrCalculatorValueFn"
        [getDscrCalculatorValueFn]="getDscrCalculatorValueFn"
        [getApplicationAuditLogsFn]="getApplicationAuditLogsFn"
        [allowContractGeneration]="allowContractGeneration"
        [getActiveContractForApplicationFn]="getActiveContractForApplicationFn"
        [getDscrCalculatorHistoryFn]="getDscrCalculatorHistoryFn"
        [declineContractFn]="declineContractFn"
        [runCreditFlowFn]="runCreditFlowFn"
        [getCreditWebServicesFn]="getCreditWebServicesFn"
        [getApplicationCreditFlowResultFn]="getApplicationCreditFlowResultFn"
        [getHistoricalContractsFn]="getHistoricalContractsFn"
        [getPismoContractsFn]="getPismoContractsFn"
        [downloadCreditorWatchReportFn]="downloadCreditorWatchReportFn"
        [updateCreditStatusFn]="updateCreditStatusFn"
        [updateCreditOfficerFn]="updateCreditOfficerFn"
        [getActiveCreditUsersFn]="getActiveCreditUsersFn"
        [getCreditAuditLogFn]="getCreditAuditLogFn"
        [getWebServiceReportFn]="getWebServiceReportFn"
        [getDuplicatedApplicationsFn]="getDuplicatedApplicationsFn"
        [deleteWebServicesFn]="deleteWebServicesFn"
        (clickApplicationEvent)="onClickApplicationEvent($event)"
        [requestMoreInformationFn]="requestMoreInformationFn"
        [withdrawApplicationFn]="withdrawApplicationFn"
        (refreshCreditTabEvent)="refreshCreditTab($event)"
        [getApplicationDscrFn]="getApplicationDscrFn"
        [resendContractFn]="resendContractFn"
        [application]="$any(application)"
        [getAggregatorsAndOriginatorsFn]="getAggregatorsAndOriginatorsFn"
        [getUserByAccessLevelFn]="getUserByAccessLevelFn"
        [getApplicationSettlementsOfficerFn]="getApplicationSettlementsOfficerFn"
        [getAmlOfficerCandidatesFn]="getAmlOfficerCandidatesFn">
        >
      </corporate-loans-application-details>
    }
  }
</div>
